import type { QueryClient } from '@tanstack/react-query'
import {
  getOnlineBookDetails,
  type LearningLessonDetail,
} from '@services/firebase/learning'

const ONLINE_BOOK_DETAILS_STALE_TIME_MS = 5 * 60 * 1000
const ONLINE_BOOK_DETAILS_GC_TIME_MS = 10 * 60 * 1000

interface OnlineBookDetailsQueryInput {
  readonly bookId?: string | null
  readonly lessonId: string
}

export function getOnlineBookDetailsQueryKey({
  bookId,
  lessonId,
}: OnlineBookDetailsQueryInput) {
  return ['learning', 'online-book-details', bookId ?? 'unknown-book', lessonId] as const
}

export function getOnlineBookDetailsQueryOptions(
  input: OnlineBookDetailsQueryInput,
) {
  return {
    gcTime: ONLINE_BOOK_DETAILS_GC_TIME_MS,
    queryFn: () => getOnlineBookDetails(input.lessonId),
    queryKey: getOnlineBookDetailsQueryKey(input),
    staleTime: ONLINE_BOOK_DETAILS_STALE_TIME_MS,
  }
}

export function prefetchOnlineBookDetails({
  bookId,
  lessonId,
  queryClient,
}: OnlineBookDetailsQueryInput & {
  readonly queryClient: QueryClient
}): Promise<void> {
  return queryClient
    .prefetchQuery<LearningLessonDetail[]>(
      getOnlineBookDetailsQueryOptions({ bookId, lessonId }),
    )
    .then(() => undefined)
}
